import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from '@chakra-ui/react';
import { ImageDropzone } from '@client/components/input/ImageDropzone';
import { useImageList } from '@client/components/listingForm/imageList/ImageListContext';
import { LISTING_LIMITS } from '@heirloom/common/constants';
import { FaImages } from 'react-icons/fa6';
export const AddImagesButton = ({ children = _jsx(FaImages, {}), ...buttonProps }) => {
    const { add, disabled } = useImageList();
    return (_jsx(ImageDropzone, { onAdd: add, maxFiles: LISTING_LIMITS.maxImages, disabled: disabled, trigger: _jsx(IconButton, { variant: "ghost", color: "fg.muted", ...buttonProps, children: children }) }));
};
